export default __webpack_public_path__ + "static/media/col_1.f367742f.webp";